// @flow

export type IconOptions = {
    // This is not a server side type. To avoid circular reference, move it from route.js to here.
    url: string,
    size: number,
    offset: Array<number>,
    opacity: number, // SVG fillOpacity and strokeOpacity will not be set for now. This is used for style paint icon-opacity property.
    textOpacity: number,
};

export const defaultOriginIconOptions: IconOptions = {
    url: `<svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'> <circle cx='10' cy='10' r='5.5' fill='#FFFFFF' stroke='#279E00' stroke-width='4'/> </svg>`,
    size: 0.2,
    offset: [0, 0],
    opacity: 1.0, // SVG fillOpacity and strokeOpacity will not be set for now. This is used for style paint icon-opacity for both custom PNG and the internal default SVG.
    textOpacity: 1.0,
};

export const defaultDestIconOptions: IconOptions = {
    url: `<svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'> <circle cx='10' cy='10' r='5.5' fill='#FFFFFF' stroke='#be2525' stroke-width='4'/> </svg>`,
    size: 0.2,
    offset: [0, 0],
    opacity: 1.0,
    textOpacity: 1.0,
};

export const defaultStopIconOptions: IconOptions = {
    url: `<svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'> <circle cx='10' cy='10' r='7' fill='#FFFFFF' stroke='#123EC4' stroke-width='3'/> </svg>`,
    size: 0.2,
    offset: [0, 0],
    opacity: 1.0,
    textOpacity: 1.0,
};

export function createStopIcon(routeColor: string) {
    return `<svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'> <circle cx='10' cy='10' r='7' fill='#FFFFFF' stroke='${routeColor}' stroke-width='3'/> </svg>`;
}
